module.exports = __webpack_public_path__ + "img/아이연산.e6497fc8.png";